import { SyntheticEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate, useOutletContext } from 'react-router'

import { SetupWorkspaceRoutes } from 'app/application/types'
import { ArrowRightIcon } from 'app/common/presentation/icons'

import { Button, Divider, Headline, Input } from 'components'

import accessStyles from '../AccessPage/AccessPage.module.scss'
import { UserAccessContext, isCreateWorkspaceInput } from './CreateAccess'
import styles from './CreateAccess.module.scss'

const SignUp = () => {
  const { t } = useTranslation('user')
  const navigate = useNavigate()
  const { error, formInput, handleCreateWorkspace, loggedIn, setFormInput } =
    useOutletContext<UserAccessContext>()

  const isCreateWorkspace = isCreateWorkspaceInput(formInput)

  const handleSubmit = (e: SyntheticEvent) => {
    e.preventDefault()

    if (loggedIn) {
      handleCreateWorkspace()
    } else {
      void navigate(SetupWorkspaceRoutes.Password)
    }
  }

  return (
    <>
      <div>
        <Headline>
          {isCreateWorkspace ? t('create.welcome_workspace_signup') : t('create.welcome_signup')}
        </Headline>
        <div className={accessStyles.message}>
          {isCreateWorkspace ? t('create.message_workspace_signup') : t('create.message_signup')}
        </div>
      </div>
      <Divider />
      <form onSubmit={handleSubmit}>
        <div className={accessStyles.inputs}>
          <div className={styles.name}>
            <Input
              autoComplete="given-name"
              autoFocus
              label={t('create.firstName')}
              mandatory
              onChange={
                error || loggedIn
                  ? undefined
                  : (firstName) =>
                      setFormInput((prev) => ({
                        ...prev,
                        firstName,
                      }))
              }
              placeholder={t('create.placeholder.firstName')}
              value={formInput.firstName}
            />
            <Input
              autoComplete="family-name"
              label={t('create.lastname')}
              mandatory
              onChange={
                error || loggedIn
                  ? undefined
                  : (lastName) =>
                      setFormInput((prev) => ({
                        ...prev,
                        lastName,
                      }))
              }
              placeholder={t('create.placeholder.lastname')}
              value={formInput.lastName}
            />
          </div>
          <Input
            autoComplete="username"
            error={error}
            label={t('create.email')}
            mandatory
            placeholder={t('create.placeholder.email')}
            value={formInput.email}
          />
          {isCreateWorkspaceInput(formInput) && (
            <Input
              label={t('create.workspace')}
              mandatory
              onChange={
                error
                  ? undefined
                  : (workspace) =>
                      setFormInput((prev) => ({
                        ...prev,
                        workspace,
                      }))
              }
              placeholder={t('create.placeholder.workspace')}
              value={formInput.workspace}
            />
          )}
        </div>
        <Button
          disabled={
            !formInput.firstName ||
            !formInput.lastName ||
            (isCreateWorkspace && !formInput.workspace)
          }
          rightIcon={loggedIn ? undefined : <ArrowRightIcon />}
          type="submit"
        >
          {t(loggedIn ? 'create.create' : 'create.next')}
        </Button>
      </form>
      <div className={styles.signIn}>
        {t('create.existingUser.question')}{' '}
        <Link to={'/login'}>{t('create.existingUser.signIn')}</Link>
      </div>
    </>
  )
}

export default SignUp
